module.exports = __webpack_public_path__ + "img/close-menu-icon.ebb3abef.svg";